export default function authHeader() {
  let token = localStorage.getItem('backofficetoken')
  if (token) {
    return { Authorization: 'Bearer ' + token }
  } else {
    return {}
  }
}
